import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";

const ModalDetailsPromotions = ({ open, setOpen, promotionData, type }) => {
  // console.log("Datos de la promoción:", promotionData);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle variant="h6" fontWeight="bold">
        Información de la promoción {promotionData?.nameDiscount ?? ""}
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={4}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold"> Establecimiento:</Typography>
              <Typography>
                {promotionData?.nameEstablishment ?? "Sin dato"}
              </Typography>
            </Box>
            <Box margin={2}>
              <Typography fontWeight="bold">Estatus:</Typography>
              <Typography
                sx={{
                  color: promotionData?.status === "active" ? "green" : "red",
                }}
              >
                {promotionData?.status === "active" ? "Activa" : "Inactiva"}{" "}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold">Descuento:</Typography>
              <Typography>{promotionData?.discount ?? "---"}</Typography>
            </Box>
            <Box margin={2}>
              <Typography fontWeight="bold"> Descripción:</Typography>
              <Typography>{promotionData?.description ?? "---"}</Typography>
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 5 }}>
          {promotionData?.urlImg && (
            <img
              src={promotionData?.urlImg ?? ""}
              alt="QR de descuento."
              width={200}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ModalDetailsPromotions;
